import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import {
  SearchGrid,
  SearchGridProps,
} from '@app/components/blocks/searchGrid/SearchGrid'
import { Variant } from '@app/components/core/tag/Tag'
import { StoredImage } from '@app/types/StoredImage'
import { AddressModel, labelAddressBuilder } from '@app/util/helpers'
import { useTranslations } from '@i18n/useLanguage'

type PlotSearchGridItem = {
  slug: string
  to: string
  image: StoredImage | string
  title: string
  description?: string
  address: AddressModel
  tagText: string
  tagVariant: Variant
  isSpotlight?: boolean
}

export type PlotSearchGridProps = Omit<
  SearchGridProps,
  'items' | 'gridStyle'
> & {
  items: PlotSearchGridItem[]
  totalItems: number
}

export const PlotSearchGrid = (props: PlotSearchGridProps) => {
  const notSpecified = useTranslations().app.common.notSpecified
  return (
    <SearchGrid
      {...props}
      isTitlePageHeader={true}
      items={props.items.map((i) => renderCard(i, notSpecified))}
      gridStyle={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(250px, 1fr))',
        '@media (max-width: 1200px)': {
          gridTemplateColumns: 'repeat(2, minmax(250px, 1fr))',
        },
        gap: '1.5rem',
      }}
      hasMore={props.items.length < props.totalItems}
    />
  )
}

const renderCard = (item: PlotSearchGridItem, notSpecified: string) => {
  const { address, ...rest } = item
  return (
    <InitiativeCard
      key={item.slug}
      variant={item.isSpotlight ? 'spotlight' : 'default'}
      {...rest}
      location={labelAddressBuilder(address, notSpecified) ?? notSpecified}
      description={undefined}
    />
  )
}
